/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { ComplexCtaCardsSectionFragment } from "@cosmos/hygraph-schema";

import { ResponsiveContainer, SectionContainer, SectionHeading, BackgroundContainer } from "@components/elements";
import { extractBackgroundContainerProps, extractSectionContainerProps } from "@components/utils/section.utils";
import { css, cx } from "@panda/css";
import { VStack } from "@panda/jsx";

import { ComplexCtaCards } from "./ComplexCtaCards.organism";

export const ComplexCtaCardsSection = ({
	config,
	cards,
	bottomDescription,
	complexCtaVariant,
}: ComplexCtaCardsSectionFragment): React.JSX.Element | null => {
	const validHeading = Boolean(config?.heading?.title || config?.heading?.desc);
	const validContent = Boolean(cards?.length || bottomDescription);
	if (!validHeading && !validContent) return null;
	return (
		<BackgroundContainer {...extractBackgroundContainerProps(config)}>
			<ResponsiveContainer>
				<SectionContainer {...extractSectionContainerProps(config)}>
					<VStack
						alignItems="stretch"
						gap="eds.dimension.48"
						className={cx(
							"complex-cta-cards-section",
							css({
								mdDown: {
									gap: "eds.dimension.40",
								},
							}),
						)}
					>
						{validHeading ? <SectionHeading {...config?.heading} titleDescStack={{ gap: "eds.dimension.16" }} /> : null}
						{validContent ? (
							<ComplexCtaCards
								cards={cards || []}
								bottomDescription={bottomDescription}
								complexCtaVariant={complexCtaVariant}
							/>
						) : null}
					</VStack>
				</SectionContainer>
			</ResponsiveContainer>
		</BackgroundContainer>
	);
};
